<template>
  <v-layout align-center column>
    <p class="Section-Title">Meet Our Leaders</p>
    <!-- <p class="Quote-Text">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut viverra neque,
      senectus egestas non est duis.
    </p> -->
    <v-row class="my-6" no-gutters>
      <v-col sm="5" md="6">
        <p class="Name" style="margin-left: 0.75rem;">
          Sunu Widyatmoko
        </p>
        <p class="Position" style="margin-left: 0.75rem;">
          Cofounder & CEO
        </p>
        <img
          src="../../assets/TentangKami/Sunu-Widyatmoko.png"
          srcset="../../assets/TentangKami/Sunu-Widyatmoko@2x.png 2x"
          class="Sunu-Widyatmoko Image"
        />

        <a
          class="no-line"
          href="https://id.linkedin.com/in/sunu-widyatmoko-b13455b"
        >
          <div class="Shape">
            <v-row style="margin: 0.125rem 0 0;">
              <img
                src="../../assets/TentangKami/linkedin.png"
                srcset="
                  ../../assets/TentangKami/linkedin@2x.png 2x,
                  ../../assets/TentangKami/linkedin@3x.png 3x
                "
                class="linkedin"
              />
              <span class="title-1">Let’s connect!</span>
            </v-row>
          </div>
        </a>
      </v-col>
      <v-col class="px-2" />
      <v-col sm="5" offset-sm="2" md="6" offset-md="0">
        <p class="Name" style="margin-left: 1.25rem;">
          Endra Masagung
        </p>
        <p class="Position" style="margin-left: 0.125rem;">
          Cofounder & Chairman
        </p>
        <img
          src="../../assets/TentangKami/Endra-Masagung-2.png"
          class="Endra-Masagung Image"
        />
        <a
          class="no-line"
          href="https://id.linkedin.com/in/endra-masagung-47984ab"
        >
          <div class="Shape">
            <v-row style="margin: 0.125rem 0 0;">
              <img
                src="../../assets/TentangKami/linkedin.png"
                srcset="
                  ../../assets/TentangKami/linkedin@2x.png 2x,
                  ../../assets/TentangKami/linkedin@3x.png 3x
                "
                class="linkedin"
              />
              <span class="title-1">Let’s connect!</span>
            </v-row>
          </div>
        </a>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col sm="5" md="6">
        <p class="Name" style="margin-left: 1.8rem;">
          Arif Medianto
        </p>
        <p class="Position" style="margin-left: 0.6rem;">
          Cofounder & Board
        </p>

        <img
          src="../../assets/TentangKami/Arif-Medianto.png"
          srcset="
            ../../assets/TentangKami/Arif-Medianto@2x.png 2x,
            ../../assets/TentangKami/Arif-Medianto@3x.png 3x
          "
          class="Arif-Medianto Image"
        />

        <a
          class="no-line"
          href="https://id.linkedin.com/in/arifmedianto?trk=people-guest_people_search-card"
        >
          <div class="Shape">
            <v-row style="margin: 0.125rem 0 0;">
              <img
                src="../../assets/TentangKami/linkedin.png"
                srcset="
                  ../../assets/TentangKami/linkedin@2x.png 2x,
                  ../../assets/TentangKami/linkedin@3x.png 3x
                "
                class="linkedin"
              />
              <span class="title-1">Let’s connect!</span>
            </v-row>
          </div>
        </a>
      </v-col>
      <v-col class="px-2" />
      <v-col sm="5" offset-sm="2" md="6" offset-md="0">
        <p class="Name" style="margin-left: 1.75rem;">
          Sandrine Azhar
        </p>
        <p class="Position" style="margin-left: 0.125rem;">
          Chief Risk Officer (CRO)
        </p>
        <img
          src="../../assets/TentangKami/Sandrine-Azhar.png"
          srcset="
            ../../assets/TentangKami/Sandrine-Azhar@2x.png 2x,
            ../../assets/TentangKami/Sandrine-Azhar@3x.png 3x
          "
          class="Arif-Medianto Image"
        />

        <a
          class="no-line"
          href="https://id.linkedin.com/in/sandrine-azhar-08344b4b"
        >
          <div class="Shape">
            <v-row style="margin: 0.125rem 0 0;">
              <img
                src="../../assets/TentangKami/linkedin.png"
                srcset="
                  ../../assets/TentangKami/linkedin@2x.png 2x,
                  ../../assets/TentangKami/linkedin@3x.png 3x
                "
                class="linkedin"
              />
              <span class="title-1">Let’s connect!</span>
            </v-row>
          </div>
        </a>
      </v-col>
    </v-row>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      heroTextSize: `48px`,
      textMarginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 6}px`,
      width: `${window.innerWidth / 4}px`,
      fontSize: `40px`,
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.textMarginLeft = `${window.innerWidth / 40}px`;
      this.marginTop = `${window.innerWidth / 7}px`;
      this.width = `${window.innerWidth / 2}px`;
      this.fontSize = `${window.innerWidth / 32}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.Shape {
  width: 166px;
  height: 36px;
  flex-grow: 0;
  padding: 5px 23px 9.3px 24px;
  border-radius: 22px;
  border: solid 2px #252525;
}
.Section-Title {
  width: 328px;
  height: 23px;
  flex-grow: 0;
  margin: 0 0 16px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Quote-Text {
  width: 285px;
  height: 63px;
  flex-grow: 0;
  margin: 16px 21px 1px 22px;
  font-family: Inter;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Name {
  height: 15px;
  flex-grow: 0;
  margin: 145px 0 0 auto;
  padding-left: 18px;
  font-family: Sora;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  position: absolute;
}
.Position {
  height: 12px;
  flex-grow: 0;
  margin: 162px 0 0;
  padding-left: 30px;
  font-family: Inter;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  position: absolute;
}
.Sunu-Widyatmoko {
  width: 285px;
  height: 350px;
  flex-grow: 0;
  object-fit: contain;
}
.linkedin {
  height: 16px;
  flex-grow: 0;
  margin: 0 6px -0.7px 0;
  object-fit: contain;
}
.Endra-Masagung {
  width: 285px;
  height: 350px;
  flex-grow: 0;
  object-fit: contain;
}
.Arif-Medianto {
  width: 285px;
  height: 350px;
  flex-grow: 0;
  object-fit: contain;
}
.Image {
  width: 156px;
  height: 191.6px;
  flex-grow: 0;
  margin: 0 0 0 6px;
  border-radius: 8px;
  box-shadow: 0 4px 35px 0 rgba(0, 0, 0, 0.05);
}
.title-1 {
  height: 15px;
  flex-grow: 0;
  margin: 1.7px 0 0 6px;
  font-family: Sora;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.no-line {
  color: #ffffff;
}
</style>
